import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'any'
})
export class OrderStateService {

	constructor () { }

	hasUnsavedChanges: boolean = false;

	/**
	 * Material Id changes must be separated from other order changes to allow multiple material adjustments.
	 * This way the materials can be changed when order has no other changes, but both types of changes must be checked to allow the app to navigate away from the open order.
	 */
	hasUnsavedMaterialChanges: boolean = false;
}
